import React from "react";
import { Link } from "react-router-dom";

function Reserve_header(){

    return(
        <div className="reserve-header">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>رزرو میز</h1>
                        <div className="breadcrumbs">
                            <Link to="/">صفحه اصلی</Link>
                            <i className="fas fa-angle-left"></i>
                            <span className="current-page">رزرو میز</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Reserve_header;